export default "__VITE_ASSET__CWqc445Z__"